import { getToken } from "../../../apis/authentication";
import { SERVER_URLS } from "../../../appConstants";

export const getBhuMeetPerformanceAPI = async(filters) => {
    try {
        const token = getToken();
        // setting from month -1 as needed for get last month data
        const from = new Date(filters.from)
        filters.from = new Date(from.getFullYear(), from.getMonth() - 1, 1, 0, 0, 0, 0).toISOString()
        const response = await fetch(
            SERVER_URLS.BACKEND_SERVER + "/bhumeet_team/operations/bhumeetPerformance",
            {
                method: "POST",
                body: JSON.stringify({filters}),
                headers: {
                    Authorization: `Bearer ${token} `,
                    "Content-Type": "application/json"
                },
            }
        );

        const res = await response.json();
        if (!response.ok) {
            throw (res.message || "Something went wrong while getting bhumeet performance data.");
        }
        return res;

    } catch (err) {
        throw (err || "Something went wrong while getting bhumeet performance data.");
    }

};


export const getTotalPerformanceOverView=async(filters)=>{
    try{
        const token = getToken();
        // setting from month -1 as needed for get last month data
        const from = new Date(filters.from)
        filters.from = new Date(from.getFullYear(), from.getMonth() - 1, 1, 0, 0, 0, 0).toISOString()
        const response = await fetch(
            SERVER_URLS.BACKEND_SERVER + "/bhumeet_team/operations/bhumeetPerformance/overview",
            {
                method: "POST",
                body: JSON.stringify({filters}),
                headers: {
                    Authorization: `Bearer ${token} `,
                    "Content-Type": "application/json"
                },
            }
        );

        const res = await response.json();
        if (!response.ok) {
            throw (res.message || "Something went wrong while getting bhumeet performance data.");
        }
        console.log("response in the getTotalPerformanceOverView ",res);
        return res;
    }catch(err){
     console.log("error",err);
        throw (err || "Something went wrong while getting bhumeet performance data.");
    }
}